import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {Dialog, DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {Tabs} from "shared/controls/Tabs/Tabs";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {AttachToEmailOptions, DocumentManagerOptions} from "../../Manager/PDFManager/DocumentManager.Options";
import {SelectAPDF} from "../../Controls/SelectAPDF";
import {DocumentManager} from "../../Manager/PDFManager/DocumentManager";
import {RNTags} from "shared/controls/RNTags/RNTags";
import {RNTagGroup} from "shared/controls/RNTags/RNTagGroup";
import {RNTagItem} from "shared/controls/RNTags/RNTagItem";
import {LicenseRequired} from "../../../PDFList/LicenseRequired";
import {faStar} from "@fortawesome/free-regular-svg-icons/faStar";
import {ToastService} from "shared/core/services/ToastService";
import {faMapSigns} from "@fortawesome/free-solid-svg-icons/faMapSigns";
import {ConditionTab} from "./Conditions/ConditionTab";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {FontDialog} from "../FontDialog";

export class TemplateSettings extends DynamicDialog<TemplateSettingsProps, TemplateSettingsState> {
    static defaultProps: Partial<TemplateSettingsProps> = {};

    constructor(props: TemplateSettingsProps) {
        super(props);
        this.state = {
            IsOpen: true,
            IsBusy: false,
            OpenedTab:"settings"
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Template Settings',
            Icon:<FontAwesomeIcon icon={faCog}/>,
            Styles:{width:'80%',maxWidth:800},
            CancelTitle:'Close'
        };
    }

    SubRenderer(): ReactNode {
        let form=rnImporterVar.FormList.find(x=>x.Id==this.props.DocumentManager.Options.FormId);
        let notifications=form?.Notifications??[];

        return(
            <div>
                <Tabs TabToOpen={this.state.OpenedTab} TabToOpenChanged={x=>this.setState({OpenedTab:x})}>
                  <Tabs.Item Title={'General Settings'} Id={'settings'} Icon={<FontAwesomeIcon icon={faCog}/>}>
                      <SearchableSelect<DocumentManagerOptions> Label={'Selected form'} Value={this.props.DocumentManager.Options.FormId} onChange={e=>{this.props.DocumentManager.SetFormId(e);this.forceUpdate()}}>
                          {rnImporterVar.FormList.map(form=>
                              <option value={form.Id} key={form.Id}>{form.Name}</option>
                          )}
                      </SearchableSelect>

                      <SelectAPDF Manager={this.props.DocumentManager}/>
                  </Tabs.Item>
                    <Tabs.Item Title={'Advanced (Full version only)'} Id={'advanced'} Icon={<FontAwesomeIcon icon={faStar}/>}>
                        <RNTags<DocumentManagerOptions> Label={'PDF File Name'} Store={this.props.DocumentManager.Options} PropertyName={"PDFFileName"} DefaultValue={'Document'} OnOpeningDialog={()=>this.OnOpeningDialog()}>
                            <RNTagGroup IsOpen={true} Title={'General'}>
                                <RNTagItem Label={'Entry Number'} Value={'_entry_number'} Type={'fixed'}/>
                                <RNTagItem Label={'Date'} Value={'_date'} Type={'fixed'}/>
                                <RNTagItem Label={'Username of person that submitted the form'} Value={'_username'} Type={'fixed'}/>
                            </RNTagGroup>
                            <RNTagGroup IsOpen={true} Title={'Fields'}>
                                {this.props.DocumentManager.GetFields().map(x=>
                                    <RNTagItem Label={x.Label} Type={'field'} Value={x.Id}/>
                                )}
                            </RNTagGroup>
                        </RNTags>
                        <SearchableSelect style={{marginBottom:0}} Label={'Font'} Value={this.props.DocumentManager.Options.AdditionalSettings.Font}  onChange={x=>{this.props.DocumentManager.Options.AdditionalSettings.Font=x;this.forceUpdate()}}  >
                            {(rnImporterVar as any).Fonts.map(x=>
                                <option value={x}>{x}</option>
                            )}
                            <option value={''}>Default Font</option>
                        </SearchableSelect>
                        <a style={{display:'block',marginBottom:10}} href={'#'} onClick={e=>{e.preventDefault();this.OpenFont()}}>Manage your fonts</a>
                        <SearchableSelect Label={'Attach PDF in Email'} placeholder={'All Emails'} isMulti={true} Value={this.props.DocumentManager.Options.AttachToEmail.map(x=>x.Id)} onChange={x=>this.NotificationChanged(x as any)}>
                            {notifications.map(x=>
                                <option value={x.Id}>{x.Name}</option>
                            )}
                        </SearchableSelect>
                        <RNTextInput Label={'Date'} Value={this.props.DocumentManager.Options.DateFormat} placeholder={'Y-m-j'} onChange={x=>{this.props.DocumentManager.Options.DateFormat=x;this.forceUpdate()}}></RNTextInput>
                        <a href={'https://www.php.net/manual/en/datetime.format.php#refsect1-datetime.format-parameters'} target={'_blank'}>See all formatting options</a>
                    </Tabs.Item>

                    {rnImporterVar.IsPR&&
                        <Tabs.Item Id={'Condition'} Title={'Condition'} Icon={<FontAwesomeIcon icon={faMapSigns as any}/>}>
                            <ConditionTab DocumentManager={this.props.DocumentManager}/>
                        </Tabs.Item>
                    }
                </Tabs>
            </div>
        );
    }


    private OnOpeningDialog() {
        if(rnImporterVar.IsPR=='')
        {
            Dialog.Show(<LicenseRequired Message={'Tags are only available in the full version'} URL={rnImporterVar.PurchaseURL}/>);
            return false;
        }

        return true;
    }

    private NotificationChanged(newEmailIds: { value:string }[]) {
        if(rnImporterVar.IsPR==''&&newEmailIds.length>0)
        {
            Dialog.Show(<LicenseRequired Message={'This feature is only available in the full version'} URL={rnImporterVar.PurchaseURL}/>);
            return;
        }

        let alreadySavedEmails=this.props.DocumentManager.Options.AttachToEmail;

        for(let i=0;i<alreadySavedEmails.length;i++)
        {
            if(!newEmailIds.map(x=>x.value).some(x=>x==alreadySavedEmails[i].Id))
                alreadySavedEmails.splice(i,1);
        }

        for(let newEmail of newEmailIds)
        {
            if(!alreadySavedEmails.some(x=>x.Id==newEmail.value))
            {
                alreadySavedEmails.push(new AttachToEmailOptions().Merge({Id:newEmail.value}))
            }
        }
        this.forceUpdate();

    }

    private async OpenFont() {
        let result=await Dialog.Show(<FontDialog/>)
        this.forceUpdate();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateSettingsProps extends DynamicDialogProps {
    DocumentManager:DocumentManager;
}

interface TemplateSettingsState extends DynamicDialogState {
    OpenedTab:'settings';
}

//#endregion "My Region"